(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mtc-product-prices"] && !Shopify.designMode) return;
  try {
    const CART_UPDATE_EVENT = 'cart:update';

  function initUpsell(el) {
    const productId = parseInt(el.dataset.productId);
    const boxQty = parseInt(el.dataset.boxQty);
    const boxPrice = el.dataset.boxPrice;

    function update(cart) {
      const cartQty = cart.items
        .filter((item) => item.product_id === productId)
        .reduce((sum, item) => sum + item.quantity, 0);

      const gap = boxQty - cartQty;

      if (cartQty > 0 && gap > 0) {
        el.textContent = `Add ${gap} more to unlock box pricing — ${boxPrice} each`;
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    }

    document.addEventListener(CART_UPDATE_EVENT, (e) => {
      if (e.detail?.resource) update(e.detail.resource);
    });

    fetch('/cart.js')
      .then((r) => r.json())
      .then(update)
      .catch(() => {});
  }

  document.querySelectorAll('.mtc-pdp-upsell[data-box-qty]').forEach(initUpsell);
  } catch(e) { console.error(e); }
})();

})();
